
const serverURL = process.env.API_URL || "https://ts-movie-server-mini.herokuapp.com" ;
//const serverURL = "http://0.0.0.0:3000";

export default serverURL;
